export default [
  {
    path: 'creator',
    name: 'Creator',
    component: () => import('@/views/admin/creator/creator.vue'),
    meta: { title: '创作', requireAuth: true, requireAdmin: true },
    children: [
      {
        path: 'draft/list',
        component: () => import('@/views/admin/creator/draft/list.vue'),
        meta: { title: '草稿管理', tabbar: 'draft' }
      },
      {
        path: 'draft/export-list',
        component: () => import('@/views/admin/creator/draft/list.vue'),
        props: { exportOnly: true },
        meta: { title: '草稿导出', tabbar: 'export' }
      }
    ]
  }
]
